import {clientService} from '../network/services/client.service';
import {ResponseError} from "../network/response/response-error";

export default {
  namespaced: true,
  state: {
    addresses: [],
    loading: false,
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = !!payload;
    },
    SET_ADDRESSES(state, payload) {
      state.addresses = payload;
    },
  },
  actions: {
    async fetch(context) {
      if (!context.rootState.client.tokens.accessToken) return;
      context.commit('SET_LOADING', true);
      const response = await clientService.getAddresses(context.rootState.client.tokens.accessToken);
      const addresses = response.get('Auth.addresses', []);
      if (!(addresses instanceof ResponseError)) {
        context.commit('SET_ADDRESSES', addresses);
      } else {
        // TODO catch errors
      }
      context.commit('SET_LOADING', false);
    },
    async create(context, params) {
      if (!context.rootState.client.tokens.accessToken) return;
      context.commit('SET_LOADING', true);
      const response = await clientService.createAddress(context.rootState.client.tokens.accessToken, params);
      const created = response.get('Auth.createAddress.inserted', false);
      if (created instanceof ResponseError) {
        // TODO catch errors
      }
      if (created === false) {
        // TODO catch errors
      }
      return context.dispatch('clientAddresses/fetch', null, {root: true});
    },
    async delete(context, address_id) {
      if (!context.rootState.client.tokens.accessToken) return;
      context.commit('SET_LOADING', true);
      const response = await clientService.deleteAddress(context.rootState.client.tokens.accessToken, address_id);
      const deleted = response.get('Auth.deleteAddress.deleted', false);
      if (deleted instanceof ResponseError) {
        // TODO catch errors
      }
      if (deleted === false) {
        // TODO catch errors
      }
      return context.dispatch('clientAddresses/fetch', null, {root: true});
    },
    async update(context, params) {
      if (!context.rootState.client.tokens.accessToken) return;
      context.commit('SET_LOADING', true);
      const response = await clientService.updateAddress(context.rootState.client.tokens.accessToken, params);
      const updated = response.get('Auth.updateAddress.updated', false);
      if (updated instanceof ResponseError) {
        // TODO catch errors
      }
      if (updated === false) {
        // TODO catch errors
      }
      return context.dispatch('clientAddresses/fetch', null, {root: true});
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/client-addresses.js